import { all, fork } from 'redux-saga/effects';
import send from './send';

export default function* sendbird() {
  yield all([fork(send)]);
}
